import { render, staticRenderFns } from "./DocumentState.vue?vue&type=template&id=2f8a1e41&"
import script from "./DocumentState.vue?vue&type=script&lang=js&"
export * from "./DocumentState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports